<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Remove Association</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!isLoading()">

    <div class="alert alert-warning">
      This will remove all members and managers from this association, and permenantly remove the association.
    </div>

    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input"
             id="confirmChecked"
             [(ngModel)]="confirmChecked">
      <label class="custom-control-label checkbox-label"
             for="confirmChecked">
        I want to permanently remove this association
      </label>
    </div>

    <div class="alert alert-danger mt-3 mb-0" *ngIf="errorMessage !== ''">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-body" *ngIf="isLoading()">
    <div class="alert alert-info">
      {{ getLoadingMessage() }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger"
            [disabled]="!confirmChecked"
            [class.disabled]="!confirmChecked"
            *ngIf="!isLoading()"
            (click)="handleSubmit()">
      Remove
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="isLoading()">
      Loading...
    </button>
  </div>

</ng-container>
